import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminRequest, getAdminHeaders } from "./adminApi";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setError("");
      const { res, data } = await adminRequest("/api/admin/stats", {
        headers: getAdminHeaders(),
      });

      if (!res.ok) {
        setError(data?.detail || "加载统计数据失败");
        return;
      }

      setStats(data);
    } catch (err) {
      console.error(err);
      setError("无法连接后台服务，请确认后端已启动");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-gray-400">加载中...</div>;
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">后台总览</h1>

      {error ? (
        <div className="mb-4 rounded-xl bg-red-50 text-red-600 px-4 py-3 text-sm">
          {error}
        </div>
      ) : null}

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5 mb-8">
        <StatCard title="注册用户" value={stats?.users || 0} />
        <StatCard title="咨询师" value={stats?.consultants || 0} />
        <StatCard title="咨询消息" value={stats?.consultant_messages || 0} />
        <StatCard title="订单数量" value={stats?.orders || 0} />
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5 mb-8">
        <StatCard title="今日 PV" value={stats?.page_views_today || 0} />
        <StatCard title="7 日 PV" value={stats?.page_views_7d || 0} />
        <StatCard title="资料浏览（累计）" value={stats?.profile_views_total || 0} />
        <StatCard title="资料浏览（7 日）" value={stats?.profile_views_7d || 0} />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <section className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">待办事项</h2>
          <div className="space-y-3 text-gray-600">
            <TodoItem label="咨询师认证审核" value={stats?.pending_consultants || 0} />
            <TodoItem label="用户实名审核" value={stats?.pending_user_verify || 0} />
            <TodoItem
              label="资料认证待审"
              value={stats?.pending_profile_verify || 0}
              to="/admin/users"
            />
            <TodoItem label="待处理投诉/反馈" value={stats?.pending_reports || 0} />
          </div>
        </section>

        <section className="bg-white rounded-2xl shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-gray-800">访问统计</h2>
            <Link
              to="/admin/analytics"
              className="text-sm text-blue-600 hover:underline"
            >
              查看详情 →
            </Link>
          </div>
          <p className="text-sm text-gray-500">
            站内 PV、热门页面、资料浏览记录；配合百度统计查看全站流量来源。
          </p>
        </section>
      </div>
    </div>
  );
}

function StatCard({ title, value }) {
  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <p className="text-gray-400 text-sm">{title}</p>
      <p className="text-3xl font-bold text-gray-800 mt-3">{value}</p>
    </div>
  );
}

function TodoItem({ label, value, to }) {
  const inner = (
    <div className="flex items-center justify-between bg-gray-50 rounded-xl px-4 py-3">
      <span>{label}</span>
      <span className="font-bold text-blue-600">{value}</span>
    </div>
  );
  if (!to) return inner;
  return (
    <Link to={to} className="block hover:opacity-90">
      {inner}
    </Link>
  );
}
